<template>
    <main>
        <div v-if="!landscape">
            Ruota il dispositivo per acquisire la firma.

            <button type="button"
                    class="btn btn-secondary"
                    @click.prevent="close"
            >Annulla</button>
        </div>
        <template v-else>
            <div style="width: 100%; height: 100%; overflow: hidden">
                <canvas ref="canvas" style="background: #cdcdcd;border:1px solid black;"></canvas>
            </div>

            <div class="btn-group">
                <button type="button"
                        class="btn btn-primary"
                        @click.prevent="saveImage"
                >Acquisisci</button>
                <button type="button"
                        class="btn btn-danger"
                        @click.prevent="clear"
                >Clear</button>
                <button type="button"
                        class="btn btn-secondary"
                        @click.prevent="close"
                >Annulla</button>
            </div>
        </template>
    </main>
</template>

<script>

import trimCanvas from 'trim-canvas';
import SignaturePad from 'signature_pad';

export default {
    name: 'GetSignCard',
    data() {
        return {
            landscape: false,

            canvas: null,
            signaturePad: null,
        };
    },
    methods: {
        clear() {
            this.signaturePad.clear();
        },
        saveImage() {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = this.canvas.width;
            canvas.height = this.canvas.height;
            context.drawImage(this.canvas, 0, 0);
            trimCanvas(canvas);

            this.$emit('save', canvas.toDataURL());
        },
        close() {
            this.$emit('close');
        },

        isLandscape() {
            if (window.screen && window.screen.orientation && window.screen.orientation.angle !== undefined) {
                return window.screen.orientation.angle === 90 || window.screen.orientation.angle === -90;
            }

            if (window.orientation !== undefined) {
                return window.orientation === 90 || window.orientation === -90;
            }

            if (window.matchMedia) {
                return window.matchMedia("(orientation: landscape)").matches;
            }

            if (screen.height && screen.width) {
                return screen.width > screen.height;
            }

            if (window.innerHeight && window.innerWidth) {
                return window.innerWidth > window.innerHeight;
            }

            return true;
        },
        setIsLandscape() {
            console.log(window.innerWidth);
            this.landscape = true; this.isLandscape();
        },
        resizeCanvas() {
            console.log('cavasresize');
            if (!this.canvas) {
                return;
            }

            this.canvas.width = this.canvas.parentElement.clientWidth;
            this.canvas.height = this.canvas.parentElement.clientHeight;
        },
    },
    created() {
        this.setIsLandscape();

        window.addEventListener("orientationchange", this.setIsLandscape, false);
    },
    mounted() {
        this.canvas = this.$refs.canvas;
        this.$nextTick().then(() => {
            this.resizeCanvas();
        });
        this.canvas.parentElement.addEventListener('resize', this.resizeCanvas);

        this.signaturePad = new SignaturePad(this.canvas);
    },
    destroyed() {
        window.removeEventListener('orientationchange', this.setIsLandscape);
    },
};

</script>
